export const navigationRoutes = {
    home: '/',
    explore: '/explore',
    bookings: '/bookings',
    contact: '/contact',
}

export const headerNavItems = [
    { name: 'Home', route: '/' },
    { name: 'Explore', route: navigationRoutes.explore },
    { name: 'Bookings', route: navigationRoutes.bookings},
    { name: 'Contact', route: navigationRoutes.contact },

]

